export const SET_CARTED = 'SET_CARTED'
export const SET_RACE_TYPES = 'SET_RACE_TYPES'
export const SET_EDIT_ITEM = 'SET_EDIT_ITEM'
export const SET_INPUT = 'SET_INPUT'
export const SET_TIMESLOT = 'SET_TIMESLOT'
export const RETRIEVING_TIMESLOTS = 'RETRIEVING_TIMESLOTS'
export const SET_RETRIEVED_TIMESLOTS = 'SET_RETRIEVED_TIMESLOTS'
export const SET_RETRIEVED_AVAILABILITY = 'SET_RETRIEVED_AVAILABILITY'
export const SET_TIMESLOT_DATA = 'SET_TIMESLOT_DATA'
export const SET_RETRIEVED_TIMESLOT_DATA = 'SET_RETRIEVED_TIMESLOT_DATA'
export const SET_RETRIEVED_TIMESLOT_DATA_ITEMS = 'SET_RETRIEVED_TIMESLOT_DATA_ITEMS'
export const UNSET_TIMESLOT = 'UNSET_TIMESLOT'
export const CLEAN_TIMESLOTS = 'CLEAN_TIMESLOTS'
export const UNSET_SLOTTED_MEMBERS = 'UNSET_SLOTTED_MEMBERS'
export const SET_LOCAL_CART_ITEM = 'SET_LOCAL_CART_ITEM'
export const UNSET_LOCAL_CART_ITEM = 'UNSET_LOCAL_CART_ITEM'
export const CLEAR_LOCAL_CART_ITEMS = 'CLEAR_LOCAL_CART_ITEMS'
export const ADD_RACER_DETAILS_ITEM = 'ADD_RACER_DETAILS_ITEM'
export const UPDATE_RACER_DETAILS_ITEM = 'UPDATE_RACER_DETAILS_ITEM'
export const DELETE_RACER_DETAILS_ITEM = 'DELETE_RACER_DETAILS_ITEM'
export const IS_HYDRATING_DATA = 'IS_HYDRATING_DATA'
export const SET_PRODUCT_ACCESSORIES = 'SET_PRODUCT_ACCESSORIES'
